import { itemTypeObj } from "@/constants/items";
import DefaultInstance from "@/instance/axios";
import { setToLocaleString } from "@/utils/unitMark";
import { ItemsGet200ResponseRowsInnerLotsInnerInventoriesInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export type InventoryOption = {
  value: string;
  label: string;
  isDisabled: boolean;
};

const getAutoCompleteKeyword = (keyword: string, query: any) =>
  DefaultInstance.inventoriesFindPost({
    query: JSON.stringify(query),
    search: keyword ? keyword : "",
    searchFields: ["lotName"], // 로트명으로 검색하기 위함.
    populate: ["lot", "itemWithGrade"],
    sort: "-createdAt",
  });

export const useInventoriesAutoComplete = (
  query = {},
  keyword = "",
  options?: {
    onSuccess: (data: InventoryOption[]) => void;
  }
) => {
  return useQuery(
    ["Inventories-get-autocomplete", keyword, query],
    () => getAutoCompleteKeyword(keyword, query),
    {
      select: (
        response: AxiosResponse<
          ItemsGet200ResponseRowsInnerLotsInnerInventoriesInner[],
          any
        >
      ) => {
        return (
          response.data?.map((inventory) => {
            return {
              value: inventory.lotId?.toString() ?? "",
              label: `로트명: ${inventory.lot?.name ?? "-"}, 품목군: ${
                itemTypeObj[
                  inventory.itemWithGrade?.itemType as keyof typeof itemTypeObj
                ] ?? "-"
              }, 품목명: ${inventory.itemWithGrade?.name ?? "-"}, Grade : ${
                inventory.itemWithGrade?.gradeName ?? "-"
              }, Color : ${
                inventory.itemWithGrade?.itemCategoryName ?? "-"
              }, 형태 : ${
                inventory.itemWithGrade?.abstractItemCode ?? "-"
              }, 수량: ${setToLocaleString(inventory.quantity)}`,
              isDisabled:
                !!inventory?.quantity && Number(inventory.quantity) < 0,
              data: inventory,
            };
          }) ?? []
        );
      },
      onSuccess: options?.onSuccess,
    }
  );
};
